export interface Attachment {
  dataUrl: string;
  name: string;
}

export const MAX_ATTACHMENTS = 4;

// Downscales to a max dimension and re-encodes as JPEG before it ever leaves
// the browser — reference photos come straight off a phone camera (often
// 10+ MB), and the request body limit plus per-request token cost both care
// about that.
export function fileToAttachment(file: File): Promise<Attachment> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(reader.error || new Error('Could not read file'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('Could not decode image'));
      img.onload = () => {
        const maxDim = 1400;
        const scale = Math.min(1, maxDim / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(new Error('Canvas unavailable'));
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve({ dataUrl: canvas.toDataURL('image/jpeg', 0.85), name: file.name });
      };
      img.src = reader.result as string;
    };
    reader.readAsDataURL(file);
  });
}
